import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { EnrichmentProgressPush } from '@/lib/types/enrichment.types';

/**
 * The last enrichment.progress push per batch, from the same SSE connection
 * the notification bell uses (see sidebar.tsx's EventSource handler).
 *
 * Not the source of the numbers on screen — those come from the enrichment
 * endpoints, which a push invalidates. What this slice is actually for is the
 * id: the progress screen mounts knowing only the userupload_id, which is why
 * that is the key here, and a push carries the stats_id sooner than the
 * uploads list returns it.
 */
export interface EnrichmentProgressState {
  byUploadId: Record<string, EnrichmentProgressPush>;
}

const initialState: EnrichmentProgressState = { byUploadId: {} };

const enrichmentProgressSlice = createSlice({
  name: 'enrichmentProgress',
  initialState,
  reducers: {
    enrichmentProgressReceived(state, action: PayloadAction<EnrichmentProgressPush>) {
      state.byUploadId[action.payload.userupload_id] = action.payload;
    },
  },
});

export const { enrichmentProgressReceived } = enrichmentProgressSlice.actions;
export default enrichmentProgressSlice.reducer;
